/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2019, Zumper
 * @description   Multi MessagingModal Constants
 */

export const RECEIVE_DATA = '@@nzr/modals/multiMessageModal/RECEIVE_DATA'
export const CLEAR_DATA = '@@nzr/modals/multiMessageModal/CLEAR_DATA'
